import React from 'react';
import { date, time } from '../../utils/date';

/**
 * Card de envío B2B — misma estructura visual que OrderItem de /recargas:
 *   - fila superior: badges de estado + hora
 *   - fila grande: nombre del negocio (donde va la cantidad en recargas)
 *     + forma de pago a la derecha
 *   - nombre del receptor (donde va el cliente en recargas)
 *   - dirección del receptor (donde va la dirección en recargas)
 *   - fila inferior: zona + tarifa | repartidor asignado
 */
function EnvioItem({ data }) {
    const negocio =
        data.business && data.business.name
            ? data.business.name
            : data.businessName || 'Sin origen';

    const direccion = data.receiverStreet1
        ? `${data.receiverStreet1}${
              data.receiverStreet2 ? ` — ${data.receiverStreet2}` : ''
          }`
        : '-';

    return (
        <div className="wrapper-order-item">
            {/* Fila superior: estado + hora */}
            <div className="wrapper-top-details">
                <p className="status-order mt-0 mb-2 d-flex align-items-center">
                    {data.estado}
                    {data.pagado && (
                        <span
                            className="badge badge-success ml-1"
                            style={{ fontSize: 11 }}
                        >
                            Pagado
                        </span>
                    )}
                </p>
                <h4 className="time-order">
                    <i className="fa fa-clock-o"></i> {data.hora}
                </h4>
            </div>

            {/* Fila grande: negocio (donde va cantidad) + forma de pago */}
            <div className="wrapper-quantity-order">
                <h4 className="quantity-order" style={{ color: 'black' }}>
                    {negocio}
                </h4>
                <span>{data.formaPago}</span>
            </div>

            {/* Nombre del receptor (donde va cliente) */}
            <div className="d-flex align-items-center justify-content-between p-0">
                <h4 className="client-name-order">{data.receiverName}</h4>
            </div>

            {/* Dirección del receptor (donde va dirección) */}
            <p className="m-0">{direccion}</p>

            {/* Fila inferior: zona + tarifa | repartidor */}
            <div className="wrapper-bottom-description mt-1">
                <p>
                    Zona {data.zona} — ${' '}
                    {Number(data.tarifaEnvio).toLocaleString('es-CO')} COP
                </p>
                {data.user ? (
                    <p className="text-right">
                        <strong>{data.user.name.split(' ')[0]}</strong>
                    </p>
                ) : (
                    <p className="text-right">
                        <strong>Por asignar</strong>
                    </p>
                )}
            </div>
        </div>
    );
}

export default EnvioItem;